const LegalUrls = Object.freeze({
  PRIVACY: 'https://www.nextjourni.com/privacy',
  TERMS: 'https://www.nextjourni.com/terms',
} as const);

export default LegalUrls;

export type LegalUrl = (typeof LegalUrls)[keyof typeof LegalUrls];
